export default {"src":"/_next/static/media/pancakeswap.4bd504ee.svg","height":24,"width":24};